/**
 * JAVASCRIPT DEVELOPER DOCUMENTATION
 *
 * Symmetry is a powerful and customizable theme designed for large-scale e-commerce stores. Built
 * using Web Components, it offers a highly modular architecture that makes customization and
 * maintenance easier than ever. In addition, Symmetry is optimized for speed, ensuring that your
 * store runs as fast as possible to provide your customers with a seamless shopping experience.
 *
 * If you would like to add your own JS to Symmetry, we recommend using this file and referencing
 * it using Theme Settings > Advanced > Custom HTML.
 *
 * As a brief overview, Symmetry:
 *  - Broadcasts many JS events.
 *  - Is built using Web Components.
 *  - Leverages 'code splitting' for some features.
 *  - Is completely custom built (no JS libraries)
 *  - Has a number of JS utilities.
 *
 *
 *
 * =================================================================================================
 * Custom JavaScript Events
 * =================================================================================================
 *
 * Symmetry broadcasts many custom events for ease of extensibility, detailed in this section.
 *
 * When in the Theme Editor, the details of each custom event will be logged out in the Dev Tools
 * console everytime it is triggered.
 *
 * Events are named in the following convention: ["on/dispatch"]:[subject]:[action] (where
 * 'dispatch' will trigger an event to occur, and 'on' indicates an event has occurred).
 *
 * All 'Return data' detailed in this section is returned within the 'event.detail' object.
 *
 * The available events are:
 *  1.  on:variant:change
 *  2.  on:cart:add
 *  3.  on:cart:error
*   4.  on:cart:after-merge
 *  5.  on:cart-drawer:before-open
 *  6.  on:cart-drawer:after-open
 *  7.  on:cart-drawer:after-close
 *  8.  on:quickbuy:before-open
 *  9.  on:quickbuy:after-open
 *  10. on:quickbuy:after-close
 *  11. dispatch:cart-drawer:open
 *  12. dispatch:cart-drawer:refresh
 *  13. dispatch:cart-drawer:close
 *  14. on:debounced-resize
 *  15. on:breakpoint-change

// Custom Blake Hill Cart Bubble Effect
// Listen for cart add events to trigger bubble animation when bubble setting is active
document.addEventListener('on:cart:add', function(event) {
  if (theme.settings.afterAddToCart === 'bubble') {
    const cartCount = document.querySelector('.cart-link__count');
    if (cartCount) {
      // Remove existing active class if present
      cartCount.classList.remove('active');
      // Trigger reflow to restart animation
      cartCount.offsetHeight;
      // Add active class for bubble animation
      cartCount.classList.add('active');
      // Remove class after animation completes
      setTimeout(() => {
        cartCount.classList.remove('active');
      }, 800);
    }
  }
});
 *
 * -------------------------------------------------------------------------------------------------
 * 1) on:variant:change
 * -------------------------------------------------------------------------------------------------
 * Fires whenever a variant is selected (e.g. Product page, Quickbuy, Featured Product etc).
 *
 * How to listen:
 * document.addEventListener('on:variant:change', (event) => {
 *  // your code here
 * });
 *
 * Returned data:
 *  - form: the product form content
 *  - variant: the selected variant object
 *  - allVariants: an array of all variants
 *  - selectedOptions: an array of currently selected options (e.g. ['Blue', 'Large'])
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 2) on:cart:add
 * -------------------------------------------------------------------------------------------------
 * Fires when a variant has been added to the cart, where it didn't exist in the cart before. This
 * event does not fire when the added variant was already in the cart.
 *
 * How to listen:
 * document.addEventListener('on:cart:add', (event) => {
 *   // your code here
 * });
 *
 * Returned data:
 *   - variantId: id of the variant that was just added to the cart
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 3) on:cart:error
 * -------------------------------------------------------------------------------------------------
 * Fires when an action related to the cart has failed, for example adding too much quantity of an
 * item to the cart.
 *
 * How to listen:
 * document.addEventListener('on:cart:error', (event) => {
 *   // your code here
 * });
 *
 * Returned data:
 *   - error: the error message
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 4) on:cart:after-merge
 * -------------------------------------------------------------------------------------------------
 * Fires after a list of cart items has finished being dynamically updated after a cart change.
 *
 * How to listen:
 * document.addEventListener('on:cart:after-merge', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 5) on:cart-drawer:before-open
 * -------------------------------------------------------------------------------------------------
 * Fires before the cart drawer opens.
 *
 * How to listen:
 * document.addEventListener('on:cart-drawer:before-open', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 6) on:cart-drawer:after-open
 * -------------------------------------------------------------------------------------------------
 * Fires after the cart drawer has finished opening.
 *
 * How to listen:
 * document.addEventListener('on:cart-drawer:after-open', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 7) on:cart-drawer:after-close
 * -------------------------------------------------------------------------------------------------
 * Fires after the cart drawer has finished closing.
 *
 * How to listen:
 * document.addEventListener('on:cart-drawer:after-close', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 8) on:quickbuy:before-open
 * -------------------------------------------------------------------------------------------------
 * Fires before the quick buy drawer opens.
 *
 * How to listen:
 * document.addEventListener('on:quickbuy:before-open', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 9) on:quickbuy:after-open
 * -------------------------------------------------------------------------------------------------
 * Fires after the quick buy drawer has finished opening.
 *
 * How to listen:
 * document.addEventListener('on:quickbuy:after-open', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 10) on:quickbuy:after-close
 * -------------------------------------------------------------------------------------------------
 * Fires after the quick buy drawer has finished closing.
 *
 * How to listen:
 * document.addEventListener('on:quickbuy:after-close', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 11) dispatch:cart-drawer:open
 * -------------------------------------------------------------------------------------------------
 * Opens the cart drawer (if enabled in the Theme Settings).
 *
 * How to trigger:
 * document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
 *
 * You can optionally pass in a 'detail' object with a property of 'opener', which specifies the DOM
 * element that should be focussed on when the drawer is closed.
 *
 * Example:
 * document.getElementById('header-search').addEventListener('keydown', (evt) => {
 *   if (evt.keyCode === 67) {
 *     evt.preventDefault();
 *     document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', {
 *       detail: {
 *         opener: evt.target
 *       }
 *     }));
 *   }
 * });
 *
 * In this example, we attach a keydown listener to the search input in the header. If the user
 * presses the 'c' key, it prevents the default behavior (which would be to type the letter 'c' in
 * the input) and dispatches the 'dispatch:cart-drawer:open' event with a 'detail' object that
 * specifies the search input as the opener. When the cart drawer is closed, focus is returned to
 * the search input.
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 12) dispatch:cart-drawer:refresh
 * -------------------------------------------------------------------------------------------------
 * Refreshes the contents of the cart drawer.
 *
 * This event is useful when you are adding variants to the cart and would like to instruct the
 * theme to re-render the cart drawer.
 *
 * How to trigger:
 * document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
 *   bubbles: true
 * }));
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 13) dispatch:cart-drawer:close
 * -------------------------------------------------------------------------------------------------
 * Closes the cart drawer.
 *
 * How to trigger:
 * document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:close'));
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 14) on:debounced-resize
 * -------------------------------------------------------------------------------------------------
 * Fires when the viewport finishes resizing (debounced to 300ms by default).
 *
 * How to listen:
 * window.addEventListener('on:debounced-resize', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 15) on:breakpoint-change
 * -------------------------------------------------------------------------------------------------
 * Fires when the breakpoint of the viewport changes.
 *
 * Example:
 * window.addEventListener('on:breakpoint-change', (event) => {
 *  if (theme.mediaMatches.md) {
 *   console.log('we are not on mobile');
 *  }
 * });
 *
 *
 *
 * =================================================================================================
 * Web Components
 * =================================================================================================
 *
 * Symmetry utilizes Web Components to the fullest.
 *
 * Web Components are a set of standardized APIs that allow developers to create custom, reusable
 * HTML elements that can be used across different web pages and applications.
 * Web Components consist of three main technologies: Custom Elements, Shadow DOM and HTML
 * Templates.
 *
 * See Mozilla for more: https://developer.mozilla.org/en-US/docs/Web/Web_Components
 *
 *
 *
 =================================================================================================
 * Third-Party JavaScript Dependencies
 * =================================================================================================
 *
 * Symmetry has no third-party JavaScript dependencies.
 *
 *
 * =================================================================================================
 *
 * Have fun! - The Clean Canvas Development Team.
 */

 /* Custom JavaScript -- Start */

window.updateCartDrawerDetails = function() {
  try {
    const cartCount = document.querySelector('.cart-link__count');
    if (cartCount) {
      cartCount.classList.remove('active');
      // Force reflow to restart animation
      void cartCount.offsetHeight; 
      cartCount.classList.add('active');
      setTimeout(() => {
        cartCount.classList.remove('active');
      }, 800);
    }

    // Safely dispatch cart change event
    try {
      document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
    } catch (eventError) {
      console.warn("Failed to dispatch on:cart:change event", eventError);
    }

    // Safely reinit Rebuy
    try {
      if (window.Rebuy) {
        if (typeof Rebuy.reinit === "function") {
          Rebuy.reinit();
        } else if (Rebuy.widgets) {
          // fallback: reinit all widgets
          Object.values(Rebuy.widgets).forEach(widget => {
            if (widget && typeof widget.init === "function") widget.init();
            if (widget && typeof widget.reinit === "function") widget.reinit();
          });
        }
      } else {
        console.warn("⚠️ Rebuy not available on window");
      }
    } catch (rebuyError) {
      console.error("Failed to reinitialize Rebuy widgets", rebuyError);
    }

  } catch (error) {
    console.error("updateCartDrawerDetails failed", error);
  }
};


setInterval(() => {
  document.querySelectorAll('.rebuy-product-info').forEach(infoEl => {
    const actionsEl = infoEl.nextElementSibling;
    
    // Only wrap if actions exists and not already wrapped
    if (actionsEl && actionsEl.classList.contains('rebuy-product-actions') && !infoEl.parentElement.classList.contains('rebuy-product-info-main')) {
      const wrapper = document.createElement('div');
      wrapper.classList.add('rebuy-product-info-main');

      infoEl.parentNode.insertBefore(wrapper, infoEl);
      wrapper.appendChild(infoEl);
      wrapper.appendChild(actionsEl);
    }
  });
}, 1000); // check every second

function initCollectionQuickBuy() {
  function initQuickBuyMobile(el) {
    try {
      if (!el || el.dataset.quickbuyInitialized) return;
      el.dataset.quickbuyInitialized = "true";

      const button = el.querySelector("button");
      if (!button) return;

      button.addEventListener("click", function (e) {
        try {
          let currentTarget = e.currentTarget;
          document.querySelectorAll(".collection-custom--quick_buy").forEach(ele => {
            ele.classList.add("visually-hidden-mobile");
            ele.closest("[collection-variants-quick_buy]").classList.remove("open");
          });

          const parentQuickBuy = currentTarget.closest("[collection-variants-quick_buy]")?.querySelector(".collection-custom--quick_buy");
          if (parentQuickBuy) {
            parentQuickBuy.classList.toggle("visually-hidden-mobile");
            parentQuickBuy.closest("[collection-variants-quick_buy]").classList.add("open");
          }
        } catch (err) {
          console.error("Quick Buy button click error:", err);
        }
      });
    } catch (err) {
      console.error("Init quick buy mobile error:", err, el);
    }
  }

  try {
    document.querySelectorAll(".collection-custom--quick_buy__mobile").forEach(initQuickBuyMobile);

    const observer = new MutationObserver(mutations => {
      try {
        mutations.forEach(mutation => {
          mutation.addedNodes.forEach(node => {
            if (node.nodeType === 1 && node.classList?.contains("collection-custom--quick_buy__mobile")) {
              initQuickBuyMobile(node);
            }
            if (node.nodeType === 1) {
              node.querySelectorAll?.(".collection-custom--quick_buy__mobile").forEach(initQuickBuyMobile);
            }
          });
        });
      } catch (err) {
        console.error("MutationObserver callback error:", err);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  } catch (err) {
    console.error("Observer setup error:", err);
  }
}

initCollectionQuickBuy();

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('[collection-variants-quick_buy]').forEach(function(wrapper) {
    const scrollContainer = wrapper.querySelector('.collection-custom--quick_buy');
    const leftArrow = wrapper.querySelector('.scroll-arrow.left');
    const rightArrow = wrapper.querySelector('.scroll-arrow.right');
    if (!scrollContainer || !leftArrow || !rightArrow) return;

    function getItems() {
      return Array.from(scrollContainer.querySelectorAll('.scroll-item'));
    }

    // Find the nearest item whose left edge is greater than current scrollLeft +1px
    function scrollToNext() {
      const items = getItems();
      const current = scrollContainer.scrollLeft;
      let nextItem = null;
      for (let i = 0; i < items.length; i++) {
        const itemLeft = items[i].offsetLeft - scrollContainer.offsetLeft;
        if (itemLeft > current + 1) { // +1 for small floating errors
          nextItem = items[i];
          break;
        }
      }
      if (nextItem) {
        scrollContainer.scrollTo({
          left: nextItem.offsetLeft - scrollContainer.offsetLeft,
          behavior: 'smooth'
        });
      } else {
        // Go to last item (fully right)
        scrollContainer.scrollTo({
          left: scrollContainer.scrollWidth - scrollContainer.clientWidth,
          behavior: 'smooth'
        });
      }
    }

    // Find the last item whose left edge is < current scrollLeft - 1px
    function scrollToPrev() {
      const items = getItems();
      const current = scrollContainer.scrollLeft;
      let prevItem = null;
      for (let i = 0; i < items.length; i++) {
        const itemLeft = items[i].offsetLeft - scrollContainer.offsetLeft;
        if (itemLeft < current - 1) {
          prevItem = items[i];
        } else {
          break;
        }
      }
      if (prevItem) {
        scrollContainer.scrollTo({
          left: prevItem.offsetLeft - scrollContainer.offsetLeft,
          behavior: 'smooth'
        });
      } else {
        // To very start
        scrollContainer.scrollTo({
          left: 0,
          behavior: 'smooth'
        });
      }
    }

    rightArrow.addEventListener('click', scrollToNext);
    leftArrow.addEventListener('click', scrollToPrev);
  });
});


// Dropdown
// document.addEventListener('DOMContentLoaded', function () {
//   var btn = document.getElementById('toggle-icons-btn');
//   var iconList = document.getElementById('icon-list');
//   btn?.addEventListener('click', function() {
//     if (iconList.style.display === "none") {
//       iconList.style.display = "block";
//     } else {
//       iconList.style.display = "none";
//     }
//   });
// });

// Popup
document.addEventListener('DOMContentLoaded', function() {
  const openBtn = document.getElementById('toggle-icons-btn');
  const closeBtn = document.getElementById('closePopup');
  const popupOverlay = document.getElementById('popupOverlay');
  const DomBody = document.getElementsByClassName('template-product')[0];
  const popupContent = document.querySelector('.product-popup-content');

  if(openBtn) {
    openBtn.addEventListener('click', function(e) {
      e.preventDefault();
      popupOverlay.classList.add('active');
      DomBody.classList.add('popup-open');
    });

    closeBtn.addEventListener('click', function() {
      popupOverlay.classList.remove('active');
      DomBody.classList.remove('popup-open');
    });

    popupOverlay.addEventListener('click', function(e) {
      if (!popupContent.contains(e.target)) {
        popupOverlay.classList.remove('active');
        DomBody.classList.remove('popup-open');
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        popupOverlay.classList.remove('active');
        DomBody.classList.remove('popup-open');
      }
    });
  }
});